




























































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GetCity, GetDistrict, GetProvinces, getObsToken } from '../api/common/index';
import { GetCurrentPsSupplierDetail, UpdateCurrentPsSupplier } from '../api/ps/index';
import { GetUserInfo } from '../api/login';
import { AccountModule } from '@/store/modules/account';

type AreaOption = {
  code: string;
  name: string;
};

type DeviceFormItem = {
  localId: string;
  modelName: string;
  quantity: number;
};

type PsSupplierDeviceResult = {
  modelName: string;
  quantity: number;
};

function normalizeArray<T>(value: T[] | null | undefined): T[] {
  return Array.isArray(value) ? value : [];
}

function createDeviceRow(device?: Partial<DeviceFormItem>): DeviceFormItem {
  return {
    localId: `${Date.now()}_${Math.random()}`,
    modelName: device && device.modelName ? device.modelName : '',
    quantity: device && device.quantity ? device.quantity : 1,
  };
}

@Component
export default class PrintMediaSupplierApply extends Vue {
  @Prop({ type: Boolean, default: false }) embedded!: boolean;
  @Prop({ type: Boolean, default: true }) showClose!: boolean;
  @Prop({ type: String, default: '完善企业基本信息' }) titleText!: string;
  @Prop({ type: String, default: '请填写供应商的基础信息及设备情况' }) subtitleText!: string;
  @Prop({ type: String, default: '/printMediaList' }) backPath!: string;

  pageLoading = false;
  submitLoading = false;
  acceptImgType = '.png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.webp,.WEBP';

  uploadServer = '';
  uploadPayload = {};

  provinceOptions: AreaOption[] = [];
  cityOptions: AreaOption[] = [];
  districtOptions: AreaOption[] = [];

  form = {
    name: '',
    supplierIntro: '',
    provinceCode: '',
    cityCode: '',
    districtCode: '',
    supplierMainProducts: '',
    logoUrl: '',
    deviceList: [createDeviceRow()],
  };

  formRules = {
    name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
    supplierIntro: [{ required: true, message: '请输入公司描述', trigger: 'blur' }],
    provinceCode: [{ required: true, message: '请选择省份', trigger: 'change' }],
    cityCode: [{ required: true, message: '请选择城市', trigger: 'change' }],
    supplierMainProducts: [{ required: true, message: '请输入主营产品', trigger: 'blur' }],
  };

  async mounted() {
    if (!AccountModule.isLogined) {
      this.$message.warning('请先登录后再申请入驻');
      this.$router.replace('/login');
      return;
    }

    this.pageLoading = true;
    try {
      await this.fetchProvinceOptions();
      await this.fetchDetail();
    } finally {
      this.pageLoading = false;
    }
  }

  async fetchProvinceOptions() {
    try {
      const res = await GetProvinces();
      this.provinceOptions = normalizeArray<AreaOption>(res);
    } catch (error) {
      this.provinceOptions = [];
    }
  }

  async fetchCityOptions(code: string) {
    try {
      const res = await GetCity({ code });
      this.cityOptions = normalizeArray<AreaOption>(res);
    } catch (error) {
      this.cityOptions = [];
    }
  }

  async fetchDistrictOptions(code: string) {
    try {
      const res = await GetDistrict({ code });
      this.districtOptions = normalizeArray<AreaOption>(res);
    } catch (error) {
      this.districtOptions = [];
    }
  }

  async fetchDetail() {
    try {
      const detail = await GetCurrentPsSupplierDetail();
      if (!detail) {
        return;
      }

      this.form.name = detail.name || '';
      this.form.supplierIntro = detail.supplierIntro || '';
      this.form.provinceCode = detail.provinceCode || '';
      this.form.cityCode = detail.cityCode || '';
      this.form.districtCode = detail.districtCode || '';
      this.form.supplierMainProducts = detail.supplierMainProducts || '';
      this.form.logoUrl = detail.logoUrl || '';
      const deviceList = normalizeArray<PsSupplierDeviceResult>(detail.deviceList).map(item =>
        createDeviceRow({
          modelName: item.modelName || '',
          quantity: item.quantity || 1,
        })
      );
      this.form.deviceList = deviceList.length ? deviceList : [createDeviceRow()];

      if (this.form.provinceCode) {
        await this.fetchCityOptions(this.form.provinceCode);
      }
      if (this.form.cityCode) {
        await this.fetchDistrictOptions(this.form.cityCode);
      }
    } catch (error) {
      const currentUserInfo = AccountModule.currentUserInfo || {};
      this.form.name = currentUserInfo.name || '';
      this.form.logoUrl = currentUserInfo.logoUrl || '';
      this.form.provinceCode = currentUserInfo.provinceCode || '';
      this.form.cityCode = currentUserInfo.cityCode || '';
      this.form.districtCode = currentUserInfo.districtCode || '';
      if (this.form.provinceCode) {
        await this.fetchCityOptions(this.form.provinceCode);
      }
      if (this.form.cityCode) {
        await this.fetchDistrictOptions(this.form.cityCode);
      }
      return;
    }
  }

  async handleProvinceChange() {
    this.form.cityCode = '';
    this.form.districtCode = '';
    this.cityOptions = [];
    this.districtOptions = [];
    if (!this.form.provinceCode) {
      return;
    }
    await this.fetchCityOptions(this.form.provinceCode);
  }

  async handleCityChange() {
    this.form.districtCode = '';
    this.districtOptions = [];
    if (!this.form.cityCode) {
      return;
    }
    await this.fetchDistrictOptions(this.form.cityCode);
  }

  async handleBeforeUpload(file: any) {
    const suffix = file.type.split('/')[1];
    const res = await getObsToken({ suffix });
    this.uploadServer = res.host;
    this.uploadPayload = {
      key: res.key,
      policy: res.policy,
      signature: res.signature,
      AccessKeyId: res.accessid,
      success_action_status: '200',
    };
    file.originalUrl = res.cdn + res.key;
  }

  handleUploadSuccess(res: any, file: any) {
    this.form.logoUrl = file.raw.originalUrl;
  }

  handleAddDevice() {
    this.form.deviceList = [...this.form.deviceList, createDeviceRow()];
  }

  handleDeleteDevice(index: number) {
    this.form.deviceList.splice(index, 1);
    if (!this.form.deviceList.length) {
      this.form.deviceList.push(createDeviceRow());
    }
  }

  buildDevicePayload() {
    return this.form.deviceList
      .map((item, index) => ({
        brandName: 'Epson',
        modelName: item.modelName,
        quantity: item.quantity || 1,
        sequence: index,
      }))
      .filter(item => item.modelName);
  }

  async syncUserInfo() {
    try {
      const userInfo = await GetUserInfo();
      userInfo && (await AccountModule.setUserInfo(userInfo));
    } catch (error) {
      return;
    }
  }

  get isPsSupplier() {
    const isPs = (AccountModule.currentUserInfo || {}).isPs;
    return isPs === true || isPs === 'true' || isPs === 1 || isPs === '1';
  }

  handleSubmit() {
    const formRef = this.$refs.formRef as any;
    if (!formRef) {
      return;
    }

    formRef.validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }

      this.submitLoading = true;
      try {
        await UpdateCurrentPsSupplier({
          ...this.form,
          deviceList: this.buildDevicePayload(),
        });
        await this.syncUserInfo();
        this.$message.success(this.isPsSupplier ? '保存成功' : '申请已提交，审核通过后可进入供应商后台');
        await this.fetchDetail();
        this.$router.push(this.backPath);
      } finally {
        this.submitLoading = false;
      }
    });
  }

  handleCancel() {
    this.$router.push(this.backPath);
  }
}
